module.exports = __webpack_public_path__ + "img/logo-tw.d6283c87.png";